export default "__VITE_ASSET__CONXCerC__"